var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDCoolingSource = function SvgDCoolingSource(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Leitungen/L\\xFCftung"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 420,
    width: 100,
    height: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 424.99 100 424.99 100 426.99 0 427.02 0 424.99",
    fill: "#437fa3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 423 100 422.97 100 422 0 422 0 423",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 428.99,
    width: 99.99,
    height: 1,
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "52 422 49 422 49 423 43 423 43 422 40 422 40 66.53 52 66.5 52 422",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 66.5,
    width: 1,
    height: 356.49,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 66.5,
    width: 2,
    height: 358.49,
    fill: "#437fa3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50 422 49.01 422 49 66.5 49.99 66.53 50 422",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "52 319 526 319 526 331 52 331 47 326 47 324 52 319",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47 324 526 324 526 325.97 47 326 47 324",
    fill: "#437fa3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49 322 526 321.97 526 321 50 321 49 322",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49 328 526 328 526 329 50 329 49 328",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "216 318.99 213.02 322 207.02 322 204 318.99 204 223.03 216 223 216 318.99",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 225.01,
    width: 1,
    height: 96.99,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 228,
    width: 2,
    height: 96,
    fill: "#437fa3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214 322 213.01 322 213 232.02 213.99 232.04 214 322",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "216 235 213 232.02 213 226.02 216 223 247.97 223 248 235 216 235",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 225,
    width: 42,
    height: 1,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 228,
    width: 37,
    height: 2,
    fill: "#437fa3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213 233 213 232.01 248 232 247.97 232.99 213 233",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "410 318.99 407.02 322 401.02 322 398 318.99 398 223.03 410 223 410 318.99",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 224,
    width: 1,
    height: 98,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 228,
    width: 2,
    height: 96,
    fill: "#437fa3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408 322 407.01 322 407 232 407.99 232.03 408 322",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "410 235 407 232.02 407 226.02 410 223 441.97 223 442 235 410 235",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 224,
    width: 42,
    height: 1,
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 228,
    width: 39,
    height: 2,
    fill: "#437fa3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407 233 407 232.01 442 232 441.97 232.99 407 233",
    fill: "#787878"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 408,
    width: 48,
    height: 72,
    fill: "#437fa3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.39 439.2 114.85 437.68 114 438.01 114.16 438.94 116.68 440.45 114.67 441.66 114.51 442.61 115.37 442.92 118.09 441.29 122.59 444 118.09 446.71 115.37 445.08 114.51 445.39 114.67 446.34 116.68 447.54 114.16 449.06 114 449.99 114.85 450.32 117.39 448.8 117.39 451.22 118.09 451.83 118.79 451.22 118.79 447.97 123.3 445.26 123.3 450.67 120.58 452.3 120.42 453.23 121.28 453.56 123.3 452.35 123.3 455.39 124 456 124.69 455.39 124.69 452.35 126.72 453.56 127.56 453.23 127.4 452.3 124.69 450.67 124.69 445.26 129.21 447.97 129.21 451.22 129.91 451.83 130.6 451.22 130.6 448.8 133.14 450.32 134 449.99 133.84 449.06 131.3 447.54 133.31 446.34 133.47 445.39 132.61 445.08 129.91 446.71 125.39 444 129.91 441.29 132.61 442.92 133.47 442.61 133.31 441.66 131.3 440.45 133.84 438.94 134 438.01 133.14 437.68 130.6 439.2 130.6 436.78 129.91 436.17 129.21 436.78 129.21 440.03 124.69 442.74 124.69 437.33 127.4 435.7 127.56 434.77 126.72 434.44 124.69 435.65 124.69 432.61 124 432 123.3 432.61 123.3 435.65 121.28 434.44 120.42 434.77 120.58 435.7 123.3 437.33 123.3 442.74 118.79 440.03 118.79 436.78 118.09 436.17 117.39 436.78 117.39 439.2",
    fill: "#fff"
  })))));
};
export default SvgDCoolingSource;